import { LP_INVESTMENT_LIST } from 'adminConstants/routes';
import Page from 'components/new/Page';
import { useLayoutContext } from 'contexts/LayoutContext';
import { useState } from 'react';
import ApproveTransaction from './ApproveTransaction';
import CompleteAllocation from './CompleteAllocation';
import FormSteps from './FormSteps';
import FormWrapper from './FormWrapper';
import RevalueInvestments from './RevalueInvestments';
import { Steps } from './shared/enums';
import StepCreateInvestment from './StepCreateInvestment';

type Props = {
  vehicleId: string;
};

const CreateInvestment: React.FC<Props> = ({ vehicleId }) => {
  const [activeStep, setActiveStep] = useState<Steps>(Steps.CreateInvestment);
  const { vehicle: selectedVehicle } = useLayoutContext();

  const [includeRevalueInvestmentsStep, setIncludeRevalueInvestmentsStep] =
    useState(false);

  if (!selectedVehicle) {
    throw new Error('Vehicle not found.');
  }

  return (
    <FormWrapper
      vehicleId={vehicleId}
      baseCurrency={selectedVehicle?.baseCurrency}
    >
      <Page
        heading="Create investment"
        spacing="lg"
        goBackAction={LP_INVESTMENT_LIST}
        withHeadingDivider
        customActions={
          <FormSteps
            vehicleId={vehicleId}
            activeStep={activeStep}
            setIncludeRevalueInvestmentsStep={setIncludeRevalueInvestmentsStep}
          />
        }
      >
        {activeStep === Steps.CreateInvestment && (
          <StepCreateInvestment
            onSuccess={() => setActiveStep(Steps.CompleteAllocation)}
            selectedVehicle={selectedVehicle}
          />
        )}
        {activeStep === Steps.CompleteAllocation && (
          <CompleteAllocation
            onSuccess={() =>
              setActiveStep(
                includeRevalueInvestmentsStep
                  ? Steps.RevalueInvestments
                  : Steps.ApproveTransaction,
              )
            }
            onCancel={() => setActiveStep(Steps.CreateInvestment)}
          />
        )}
        {activeStep === Steps.RevalueInvestments && (
          <RevalueInvestments
            onSuccess={() => setActiveStep(Steps.ApproveTransaction)}
            onCancel={() => setActiveStep(Steps.CompleteAllocation)}
          />
        )}
        {activeStep === Steps.ApproveTransaction && (
          <ApproveTransaction
            selectedVehicle={selectedVehicle}
            onCancel={() =>
              setActiveStep(
                includeRevalueInvestmentsStep
                  ? Steps.RevalueInvestments
                  : Steps.CompleteAllocation,
              )
            }
          />
        )}
      </Page>
    </FormWrapper>
  );
};

const CreateInvestmentWrapper: React.FC = () => {
  const { selectedVehicleId } = useLayoutContext();

  if (!selectedVehicleId) {
    return null;
  }

  return <CreateInvestment vehicleId={selectedVehicleId} />;
};

export default CreateInvestmentWrapper;
